import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxMaxLine1Button1Props extends ITextBoxProps {}

export const TextBoxMaxLine1Button1 = ({
  title = '',
  color = Colors.TEXT_ICON_PRIMARY,
  font = TextBoxTypes.Button1,
  maxLines = 1,
  ...rest
}: ITextBoxMaxLine1Button1Props): JSX.Element => (
  <TextBox
    title={title}
    color={color}
    font={font}
    maxLines={maxLines}
    {...rest}
  />
)
